"use client";

import { useState } from "react";
import { LinkIcon } from "@/components/icons/icons";

export function CopyLinkButton({ url }: { url: string }) {
  const [copied, setCopied] = useState(false);

  async function onCopy() {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    } catch {
      // Clipboard API may be blocked; fail silently.
    }
  }

  return (
    <button
      type="button"
      onClick={onCopy}
      aria-label={copied ? "Link copied" : "Copy link to this article"}
      className="grid size-9 place-items-center rounded-full border border-neutral-200 text-neutral-500 transition-colors hover:border-neutral-400 hover:text-neutral-950"
    >
      <LinkIcon className="size-4" aria-hidden="true" />
      <span className="sr-only">
        {copied ? "Link copied" : "Copy link to this article"}
      </span>
    </button>
  );
}
